import React from 'react';
import { motion } from 'framer-motion';

// Masked line-by-line reveal — pass "lines" as an array of strings/nodes
// mode="onLoad" animates immediately (for above-the-fold), mode="inView" waits until scrolled to.
export function RevealLines({ lines, className = '', delay = 0, stagger = 0.09, mode = 'inView' }) {
  const animateProps = mode === 'onLoad'
    ? { animate: { y: '0%' } }
    : { whileInView: { y: '0%' }, viewport: { once: true, amount: 0.15 } };
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            initial={{ y: '110%' }}
            {...animateProps}
            transition={{
              duration: 1.05,
              ease: [0.7, 0, 0.2, 1],
              delay: delay + i * stagger,
            }}
            className="block will-change-transform"
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

// Single word/line reveal wrapper
export function Reveal({ children, className = '', delay = 0, y = 40 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: [0.7, 0, 0.2, 1], delay }}
    >
      {children}
    </motion.div>
  );
}
